var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.scale > 0.2)?_c('div',{staticClass:"supported_work_time",class:{
        selected : _vm.isSelected
    },style:({
        width : _vm.getColumnWidth(this.isSelected) * _vm.scale + 'px',
		opacity: _vm.scale,
    })},[_c('transition-group',{attrs:{"name":"supported"}},_vm._l((_vm.hours),function(hour){return _c('div',{key:("column_" + _vm.index + "_cell_" + hour),staticClass:"supported__cell"})}),0)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }